import Resource from './BaseResource'

class Work extends Resource {
    constructor(config, tools, version, path) {
        super(config, tools, version, path)
    }
}

export default Work